/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CompetitionVM } from '../model/models';
import { OnlineEssayVM } from '../model/models';
import { OnlineEssayVMPaginatedListVM } from '../model/models';
import { ProblemDetails } from '../model/models';
import { SearchVM } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

export interface ReviewFeedbackItem {
    title: string;
    detail: string;
    examples: string[];
}

export interface EssayReview {
    studentName?: string;
    schoolName?: string;
    classForm?: string;
    county?: string;
    essayId?: string;
    transcription?: string;
    feedback: ReviewFeedbackItem[];
    suggestions?: string[];
    finalThought?: string;
    model?: string;
    costUsd?: number;
}

export type TranscriptionModel = 'gemini' | 'gpt4o' | 'mistral';



@Injectable({
  providedIn: 'root'
})
export class AdminCompetitionService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param competitionVM 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionAddCompetitionPost(competitionVM?: CompetitionVM, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<CompetitionVM>;
    public adminCompetitionAddCompetitionPost(competitionVM?: CompetitionVM, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<CompetitionVM>>;
    public adminCompetitionAddCompetitionPost(competitionVM?: CompetitionVM, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<CompetitionVM>>;
    public adminCompetitionAddCompetitionPost(competitionVM?: CompetitionVM, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<CompetitionVM>(`${this.configuration.basePath}/AdminCompetition/AddCompetition`,
            competitionVM,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param onlineEssayVM 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionAddEssayPost(onlineEssayVM?: OnlineEssayVM, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<OnlineEssayVM>;
    public adminCompetitionAddEssayPost(onlineEssayVM?: OnlineEssayVM, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<OnlineEssayVM>>;
    public adminCompetitionAddEssayPost(onlineEssayVM?: OnlineEssayVM, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<OnlineEssayVM>>;
    public adminCompetitionAddEssayPost(onlineEssayVM?: OnlineEssayVM, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<OnlineEssayVM>(`${this.configuration.basePath}/AdminCompetition/AddEssay`,
            onlineEssayVM,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param blobName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionDownloadBlobNameGet(blobName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<Blob>;
    public adminCompetitionDownloadBlobNameGet(blobName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public adminCompetitionDownloadBlobNameGet(blobName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public adminCompetitionDownloadBlobNameGet(blobName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream'}): Observable<any> {
        if (blobName === null || blobName === undefined) {
            throw new Error('Required parameter blobName was null or undefined when calling adminCompetitionDownloadBlobNameGet.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/AdminCompetition/download/${encodeURIComponent(String(blobName))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionGetCompetitionByIdIdGet(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<CompetitionVM>;
    public adminCompetitionGetCompetitionByIdIdGet(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<CompetitionVM>>;
    public adminCompetitionGetCompetitionByIdIdGet(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<CompetitionVM>>;
    public adminCompetitionGetCompetitionByIdIdGet(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminCompetitionGetCompetitionByIdIdGet.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CompetitionVM>(`${this.configuration.basePath}/AdminCompetition/GetCompetitionById/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionGetEssayByIdIdGet(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<OnlineEssayVM>;
    public adminCompetitionGetEssayByIdIdGet(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<OnlineEssayVM>>;
    public adminCompetitionGetEssayByIdIdGet(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<OnlineEssayVM>>;
    public adminCompetitionGetEssayByIdIdGet(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminCompetitionGetEssayByIdIdGet.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<OnlineEssayVM>(`${this.configuration.basePath}/AdminCompetition/GetEssayById/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param competitionId 
     * @param searchVM 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionGetEssaysByCompetitionIdCompetitionIdPost(competitionId: number, searchVM?: SearchVM, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<OnlineEssayVMPaginatedListVM>;
    public adminCompetitionGetEssaysByCompetitionIdCompetitionIdPost(competitionId: number, searchVM?: SearchVM, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpResponse<OnlineEssayVMPaginatedListVM>>;
    public adminCompetitionGetEssaysByCompetitionIdCompetitionIdPost(competitionId: number, searchVM?: SearchVM, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<HttpEvent<OnlineEssayVMPaginatedListVM>>;
    public adminCompetitionGetEssaysByCompetitionIdCompetitionIdPost(competitionId: number, searchVM?: SearchVM, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'}): Observable<any> {
        if (competitionId === null || competitionId === undefined) {
            throw new Error('Required parameter competitionId was null or undefined when calling adminCompetitionGetEssaysByCompetitionIdCompetitionIdPost.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<OnlineEssayVMPaginatedListVM>(`${this.configuration.basePath}/AdminCompetition/GetEssaysByCompetitionId/${encodeURIComponent(String(competitionId))}`,
            searchVM,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param searchVM 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionListCompetitionsPost(searchVM?: SearchVM, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public adminCompetitionListCompetitionsPost(searchVM?: SearchVM, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public adminCompetitionListCompetitionsPost(searchVM?: SearchVM, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public adminCompetitionListCompetitionsPost(searchVM?: SearchVM, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/AdminCompetition/ListCompetitions`,
            searchVM,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param competitionVM 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCompetitionUpdateCompetitionIdPut(id: number, competitionVM?: CompetitionVM, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public adminCompetitionUpdateCompetitionIdPut(id: number, competitionVM?: CompetitionVM, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public adminCompetitionUpdateCompetitionIdPut(id: number, competitionVM?: CompetitionVM, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public adminCompetitionUpdateCompetitionIdPut(id: number, competitionVM?: CompetitionVM, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling adminCompetitionUpdateCompetitionIdPut.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/AdminCompetition/UpdateCompetition/${encodeURIComponent(String(id))}`,
            competitionVM,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public adminCompetitionGenerateEssayReviewEssayIdPost(essayId: number, model: 'gemini' | 'gpt4o' | 'mistral' = 'gemini'): Observable<EssayReview> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');
        return this.httpClient.post<EssayReview>(
            `${this.configuration.basePath}/AdminCompetition/GenerateEssayReview/${encodeURIComponent(String(essayId))}?model=${model}`,
            null,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionGetEssayCertificateGet(essayId: number, competitionId: number): Observable<string> {
        let headers = this.defaultHeaders.set('Accept', 'application/json');
        return this.httpClient.get<string>(
            `${this.configuration.basePath}/AdminCompetition/GetEssayCertificate/${encodeURIComponent(String(essayId))}/${encodeURIComponent(String(competitionId))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionImportEssaysPost(
        competitionId: number,
        file: File,
        columnMapping: Record<string, string>
    ): Observable<EssayImportResult> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('columnMapping', JSON.stringify(columnMapping));

        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.post<EssayImportResult>(
            `${this.configuration.basePath}/AdminCompetition/ImportEssays/${encodeURIComponent(String(competitionId))}`,
            formData,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionDetectAIText(text: string, essayId?: number): Observable<PanagramResult> {
        let headers = this.defaultHeaders.set('Accept', 'application/json');
        return this.httpClient.post<PanagramResult>(
            `${this.configuration.basePath}/AdminCompetition/DetectAIText`,
            { text, essayId },
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    // ─── Certificate endpoints ────────────────────────────────────────────────

    public adminCompetitionCertificatesCompetitionIdPost(competitionId: number, search?: SearchVM, observe?: 'body', reportProgress?: boolean): Observable<any> {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = 'application/json';
        headers = headers.set('Accept', httpHeaderAcceptSelected);

        return this.httpClient.post<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/${encodeURIComponent(String(competitionId))}`,
            search,
            {
                responseType: <any>'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public adminCompetitionCertificatesAddPost(certVM?: any, observe?: 'body', reportProgress?: boolean): Observable<any> {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected = 'application/json';
        headers = headers.set('Accept', httpHeaderAcceptSelected);

        return this.httpClient.post<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/Add`,
            certVM,
            {
                responseType: <any>'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public adminCompetitionCertificatesIdDelete(id: number, observe?: 'body', reportProgress?: boolean): Observable<any> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.delete<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public adminCompetitionCertificatesEssaysCompetitionIdGet(competitionId: number): Observable<any> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.get<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/Essays/${encodeURIComponent(String(competitionId))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionCertificatesTeachersCompetitionIdGet(competitionId: number): Observable<any> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.get<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/Teachers/${encodeURIComponent(String(competitionId))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionCertificatesSchoolsCompetitionIdGet(competitionId: number): Observable<any> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.get<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/Schools/${encodeURIComponent(String(competitionId))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionCertificatesAllSchoolsCompetitionIdGet(competitionId: number): Observable<any> {
        let headers = this.defaultHeaders;
        headers = headers.set('Accept', 'application/json');

        return this.httpClient.get<any>(
            `${this.configuration.basePath}/AdminCompetition/Certificates/AllSchools/${encodeURIComponent(String(competitionId))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    public adminCompetitionCertificatesDownloadUuidGet(uuid: string): Observable<Blob> {
        let headers = this.defaultHeaders;

        return this.httpClient.get(
            `${this.configuration.basePath}/AdminCompetition/Certificates/Download/${encodeURIComponent(String(uuid))}`,
            {
                responseType: 'blob',
                withCredentials: this.configuration.withCredentials,
                headers
            }
        );
    }
}

export interface EssayImportResult {
    totalRows: number;
    successCount: number;
    skippedCount: number;
    failedCount: number;
    failedRows: EssayImportRowError[];
}

export interface EssayImportRowError {
    rowNumber: number;
    error: string;
    row: Record<string, string>;
}

export interface PanagramResult {
    prediction_short: 'AI' | 'AI-Assisted' | 'Human' | 'Mixed';
    prediction?: string;
    headline?: string;
    fraction_ai: number;
    fraction_ai_assisted: number;
    fraction_human: number;
    num_ai_segments?: number;
    num_ai_assisted_segments?: number;
    num_human_segments?: number;
    windows?: Array<{ text: string; ai_assistance_score: number; prediction: string }>;
    dashboard_link?: string;
}
